"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SummaryWithImage;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const clsx_1 = __importDefault(require("clsx"));
const SplitWithImage_1 = require("../SplitWithImage/SplitWithImage");
const variables_1 = __importDefault(require("../../styles/variables"));
const Text_1 = __importDefault(require("../Text"));
const useStyles = (0, styles_1.makeStyles)({
    icon: {
        width: variables_1.default.spacing(10),
        height: variables_1.default.spacing(10),
    },
    iconWrapper: { marginBottom: variables_1.default.spacing(2) },
    header: {
        fontWeight: variables_1.default.fonts.weight.semiBold,
        marginBottom: variables_1.default.spacing(0.5),
        wordWrap: 'break-word',
    },
    subHeader: {
        fontWeight: variables_1.default.fonts.weight.medium,
        marginBottom: variables_1.default.spacing(4),
        color: variables_1.default.colors.text.info,
    },
    defaultTextColor: { color: variables_1.default.colors.text.default },
});
function SummaryWithImage({ iconUrl, header, subHeader, body, imageAltText, imageUrl, }) {
    const classes = useStyles();
    return (react_1.default.createElement(SplitWithImage_1.SplitWithImage, { leftGridSize: 5, rightGridSize: 4, spacing: 3, imageAltText: imageAltText, imageUrl: imageUrl, mdDownHide: true },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes.iconWrapper },
                react_1.default.createElement("img", { className: classes.icon, src: iconUrl, alt: `${header} icon` })),
            react_1.default.createElement(Text_1.default, { as: "h1", className: (0, clsx_1.default)(classes.header, classes.defaultTextColor) }, header),
            react_1.default.createElement(Text_1.default, { as: "h3", className: classes.subHeader }, subHeader),
            react_1.default.createElement(Text_1.default, { className: classes.defaultTextColor }, body))));
}
